import * as types from '../constants/types'
import objectAssign from 'object-assign'

const initialState = {
  connectionError: false,
  isLoggedIn: false,
  status: '...Loading',
  userinfo: null
}

export function auth (state = initialState, action) {
  switch (action.type) {
    case types.SHOW_CUSTOM_ERROR:
      return objectAssign({}, state, {
        viewState: types.SHOW_CUSTOM_ERROR,
        error: action.error
      })

    case types.AUTH_STATE_SUCCESS:
      return objectAssign({}, state, {
        viewState: types.AUTH_STATE_SUCCESS,
        isLoggedIn: true,
        connectionError: false
      })

    case types.SERVER_ERROR:
      return objectAssign({}, state, {
        connectionError: true,
        viewState: types.SERVER_ERROR
      })

    case types.USER_LOGGED_OUT:
      return objectAssign({}, state, {
        isLoggedIn: false,
        viewState: types.USER_LOGGED_OUT
      })
    case types.STATUS_RECEIVED:
      return objectAssign({}, state, {
        viewState: types.STATUS_RECEIVED,
        status: action.status
      })
    case types.USERINFO_DID_LOAD:
      return {
        ...state,
        userinfo: action.payload.userinfo,
        viewState: types.USERINFO_DID_LOAD,
      }
    default:
      return state
  }
}
